import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import TemplateRoute from './Template/TemplateRoute';
import DocumentRoute from './Document/DocumentRoute';
import FileRoute from './File/FileRoute';
import ProfileRoute from './Profile/ProfileRoute';
import IdentityRoute from './Identity';
import BundleRoute from './Bundle/BundleRoute';
import NotificationRoute from './Notification/NotificationRoute';
import { config } from '../constants';
import PrivateRoute from './PrivateRoute';
import PageContentError from './UI/PageContentError';
import DocumentFinishedRoute from './Document/DocumentFinishedRoute';
import Dashboard from './Dashboard';
import { getUrlWithToken } from '../utils';

const redirectFirmaFront = () => {
  return getUrlWithToken(`${config.FIRMA_FRONT_URL}${window.location.pathname}`);
};

const Router = (props) => {
  return (
    <Switch>
      <Route exact path='/'>
        <Redirect to={props.config.visibleTabs[0].url} />
      </Route>
      <PrivateRoute exact path='/dashboard'>
        <Dashboard />
      </PrivateRoute>
      <PrivateRoute path='/template'>
        <TemplateRoute />
      </PrivateRoute>
      <PrivateRoute path='/document/finished'>
        <DocumentFinishedRoute />
      </PrivateRoute>
      <PrivateRoute path='/document'>
        <DocumentRoute />
      </PrivateRoute>
      <PrivateRoute path='/identity'>
        <IdentityRoute />
      </PrivateRoute>
      <PrivateRoute path='/file'>
        <FileRoute />
      </PrivateRoute>
      <PrivateRoute path='/bundle'>
        <BundleRoute />
      </PrivateRoute>
      <PrivateRoute path='/notification'>
        <NotificationRoute />
      </PrivateRoute>
      <Route path='/profile'>
        {(props) => <ProfileRoute {...props} />}
      </Route>
      <Route
        path='*'
        component={PageContentError}
      />
      {/* redirections to firma front validate(/validate), sign(/sign) and shortUrl(/s) */}
      <Route path='/validate' render={redirectFirmaFront} />
      <Route path='/sign' render={redirectFirmaFront} />
      <Route path='/s' render={redirectFirmaFront} />
    </Switch>
  );
};

export default Router;
